/**
 * isartau — Variantenwechsel ohne Sprung nach oben (12.10.2026)
 * ---------------------------------------------------------------------------
 * WAS ES TUT
 *
 *   Wechselt die Kundin eine echte Shopify-Option (Gewicht, Beschlaege,
 *   Groesse ...), schiebt Dawn die Seite zum neuen Variantenbild hoch, sobald
 *   dieses oberhalb des Bildschirms liegt. Auf dem Handy ist das fast immer so.
 *   Dieses Skript faengt genau diesen einen Hochschiebe-Befehl ab. Alles andere
 *   bleibt Dawn: Bild nach vorn, is-active, horizontales Schieben des Sliders,
 *   Videos pausieren, Live-Region.
 *
 * WO DER SPRUNG HERKOMMT (nur gelesen, nicht veraendert)
 *
 *   assets/product-info.js  updateMedia() -> setActiveMedia(<id>, true)
 *   assets/media-gallery.js setActiveMedia() plant einen window.setTimeout,
 *                           darin window.scrollTo({ top, behavior: 'smooth' })
 *
 *   prepend === true kommt ausschliesslich aus dem Variantenwechsel. Klicks auf
 *   Vorschaubilder rufen setActiveMedia mit false auf und bleiben unberuehrt.
 *   Rubik-Achsen (Modell, Farbe ...) sind echte Links und laden eine neue
 *   Seite — dort laeuft setActiveMedia gar nicht.
 *
 * WIE
 *
 *   Huelle um MediaGallery.prototype.setActiveMedia. Bei prepend === true wird
 *   window.scrollTo fuer diesen Aufruf und Dawns direkt danach eingeplanten
 *   Timeout ersetzt. Die Ersatzfassung schluckt NUR Dawns Aufrufsform
 *   ({ top, behavior: 'smooth' } ohne left) und reicht jede andere an das
 *   echte window.scrollTo durch. Unser setTimeout(…, 0) wird nach Dawns
 *   eingeplant und laeuft bei gleicher Wartezeit garantiert danach — dort
 *   kommt das Original zurueck.
 *
 * NACH EINEM DAWN-UPDATE
 *
 *   Faellt still aus, schlimmstenfalls ist der alte Sprung wieder da:
 *   kein <media-gallery> / kein setActiveMedia -> Skript tut nichts; Sprung
 *   spaeter oder in anderer Form -> wird durchgereicht. Nie ein Fehler.
 *
 * Befund und Messwerte: docs/BEFUND-pdp-variantenwechsel-scroll.md
 * Eingebunden ueber snippets/isartau-variantenwechsel-ohne-sprung.liquid aus
 * sections/main-product.liquid. Keine Dawn-Datei veraendert.
 */
(function () {
  'use strict';

  if (!window.customElements || typeof window.customElements.whenDefined !== 'function') return;

  /* Genau Dawns Aufruf aus media-gallery.js: ein Objekt mit top und
     behavior 'smooth', ohne left. Alles andere ist nicht unser Fall. */
  function istDawnsSprung(args) {
    var a = args[0];
    return (
      args.length === 1 &&
      a !== null &&
      typeof a === 'object' &&
      a.behavior === 'smooth' &&
      typeof a.top === 'number' &&
      !('left' in a)
    );
  }

  customElements.whenDefined('media-gallery').then(function () {
    var Klasse = customElements.get('media-gallery');
    var proto = Klasse && Klasse.prototype;
    if (!proto || typeof proto.setActiveMedia !== 'function') return;
    if (proto.__isartauOhneSprung) return;

    var original = proto.setActiveMedia;

    proto.setActiveMedia = function (mediaId, prepend) {
      if (prepend !== true) return original.apply(this, arguments);

      var echt = window.scrollTo;
      window.scrollTo = function () {
        if (istDawnsSprung(arguments)) return;
        return echt.apply(window, arguments);
      };

      try {
        return original.apply(this, arguments);
      } finally {
        window.setTimeout(function () {
          window.scrollTo = echt;
        }, 0);
      }
    };

    proto.__isartauOhneSprung = true;
  });
})();
